export type DocumentModel = {
  fileName: string
  documentId: string
  fileUrl?: string
  createdAt: Date
  fileSize: number
  fileExtension: string
  hubCategory: string
  project: string
}

export type DocumentsTableFilter = {
  rowsPerPage: number
  page: number
  sortColumn: string
  sortDirection: 'desc' | 'asc'
  hubCategory?: string
  createdOnFrom?: string
  createdOnTo?: string
}

export enum CategoryTypes {
  ALL = '',
  COMMON = 'All',
  FINANCE = 'Financial',
  QUALITY_ASSURANCE = 'Quality'
}
